function userStoppedStreamEventAdapter(data) {
  const { peerId, producer } = data.room.peer;

  return { peerId, producer, adapted: true };
}

export default userStoppedStreamEventAdapter;
